// extracted by css-extract-rspack-plugin
var _1 = "UJInNl7gFWQGYXRK";
var _2 = "GwfPfVTr78cBTnb4";
var _3 = "SbOjfPiG_LgNedUQ";
var _4 = "U8wTFRiDSz8pCnu8";
var _5 = "vTthnPY6GowCkXX8";
export { _1 as "langRow", _2 as "langSelect", _3 as "langSelectFullWidth", _4 as "langSwitcher", _5 as "langSwitcherFullWidth" }
// extracted by css-extract-rspack-plugin
var _1 = "UJInNl7gFWQGYXRK";
var _2 = "GwfPfVTr78cBTnb4";
var _3 = "SbOjfPiG_LgNedUQ";
var _4 = "U8wTFRiDSz8pCnu8";
var _5 = "vTthnPY6GowCkXX8";
export { _1 as "langRow", _2 as "langSelect", _3 as "langSelectFullWidth", _4 as "langSwitcher", _5 as "langSwitcherFullWidth" }
